import { fromAPI } from "@cur8/rich-entity";
import { useQuery } from "@tanstack/react-query";
import { APIClient } from "lib/api/client";
import { useAPIClient } from "render/context/APIContext";
import { useSession } from "render/context/MSALContext";
import { ExtractBody, ExtractKey, QueryOptions } from "typings/query";

const queryKey = (patientId: string, assignmentId: string) => [
  "assignment",
  patientId,
  assignmentId,
];
const queryFn =
  (apiClient: APIClient, patientId: string, assignmentId: string) =>
  async () => {
    const result = await apiClient.assignment.getAssignmentFor(
      patientId,
      assignmentId
    ).result;

    return fromAPI.toAssignment(result);
  };

type Body = ExtractBody<typeof queryFn>;
type Key = ExtractKey<typeof queryKey>;

export function useAssignmentQuery<T = Body>(
  assignmentId: string,
  options: QueryOptions<Body, Key, T> = {}
) {
  const { patientId } = useSession();
  const apiClient = useAPIClient();

  return useQuery({
    ...options,
    queryKey: queryKey(patientId, assignmentId),
    queryFn: queryFn(apiClient, patientId, assignmentId),
  });
}
